<template>
  <v-dialog v-model='dialog' fullscreen hide-overlay transition='dialog-bottom-transition'>
    <v-card>
      <div class="stickyTwo">
      <v-toolbar dark class='bgclr'>
        <v-btn icon dark @click='closeDialog'>
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn text color='white' @click='save'>Save</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      </div>
      <v-container>
        <v-form ref='form' v-model='valid' lazy-validation>
          <v-row>
            <v-radio-group v-model='radios' :mandatory='true' row @change="defaultRadio">
              <template v-slot:label>
                <div>
                  <strong>Adoption For : </strong>
                </div>
                <hr />
              </template>
              <v-radio color='success' value='1'>
                <template v-slot:label>State</template>
              </v-radio>
              <v-radio color='success' value='2'>
                <template v-slot:label>County</template>
              </v-radio>
              <v-radio color='success' value='3'>
                <template v-slot:label>Jurisdiction</template>
              </v-radio>
              <v-radio color='success' value='4'>
                <template v-slot:label>Township</template>
              </v-radio>
            </v-radio-group>
          </v-row>
          <v-row>
            <v-col cols='8' sm='4' md='4' lg='5'>
              <v-autocomplete
                validate-on-blur
                v-model='editedItem.countryId'
                :rules='countryRules'
                @change='filterState'
                :items='countryList'
                item-text='name'
                item-value='id'
                label='Country*'
                return-object
                persistent-hint
              ></v-autocomplete>
            </v-col>
            <v-col cols='8' sm='4' md='4' lg='5'>
              <v-autocomplete
                v-model='editedItem.stateId'
                :disabled='!isEditingState'
                :rules='stateRules'
                @change="filterCounty"
                :items='stateList.length >= 1 ? stateList : []'
                item-text='name'
                item-value='id'
                label='State*'
              ></v-autocomplete>
              <span
                v-if='stateErrorCheck'
                class='caption fonte-weigth-light red--text'
              >{{stateError}}</span>
            </v-col>
            <v-col v-if="this.radios === '2' || this.radios === '4'" cols='8' sm='4' md='4' lg='5'>
              <v-autocomplete
                v-model='editedItem.countyId'
                :disabled='!isEditingCounty'
                :rules="countyRules"
                @change="filterJurisdiction"
                :items='countyList.length >= 1 ? countyList : []'
                item-text='name'
                item-value='id'
                label= 'County*'
              ></v-autocomplete>
              <span
                v-if='countyErrorCheck'
                class='caption fonte-weigth-light red--text'
              >{{countyError}}</span>
            </v-col>
            <v-col v-if="this.radios === '3'" cols='8' sm='4' md='4' lg='5'>
              <v-autocomplete
                v-model='editedItem.countyId'
                :disabled='!isEditingCounty'
                @change="filterJurisdiction"
                :items='countyList.length >= 1 ? countyList : []'
                item-text='name'
                item-value='id'
                label= 'County'
                clearable
              ></v-autocomplete>
              <span
                v-if='countyErrorCheck'
                class='caption fonte-weigth-light red--text'
              >{{countyError}}</span>
            </v-col>
            <v-col v-if="this.radios === '3'" cols='8' sm='4' md='4' lg='5'>
              <v-autocomplete
                v-model='editedItem.jurisdictionId'
                :disabled='!isEditingJurisdiction'
                :rules='jurisdictionRules'
                :items='jurisdictionList.length >= 1 ? jurisdictionList : []'
                item-text='name'
                item-value='id'
                label='Jurisdiction*'
              ></v-autocomplete>
              <span
                v-if='jurisdictionErrorCheck'
                class='caption fonte-weigth-light red--text'
              >{{jurisdictionError}}</span>
            </v-col>
            <v-col v-if="this.radios === '4'" cols='8' sm='4' md='4' lg='5'>
              <v-autocomplete
                v-model='editedItem.townshipId'
                :disabled='!isEditingTownship'
                :rules='townshipRules'
                :items='townshipList.length >= 1 ? townshipList : []'
                item-text='name'
                item-value='id'
                label='Township*'
              ></v-autocomplete>
              <span
                v-if='townshipErrorCheck'
                class='caption fonte-weigth-light red--text'
              >{{townshipError}}</span>
            </v-col>
            <v-col cols='8' sm='4' md='4' lg='5'>
              <v-autocomplete
                v-model='editedItem.codeBookId'
                :rules='bookRules'
                hint='Please select a Code Book.'
                :items='codebooks'
                item-text='titleYear'
                item-value='id'
                label='Code Book*'
              ></v-autocomplete>
            </v-col>
            <v-col cols='8' sm='4' md='4' lg='5'>
              <v-autocomplete
                v-model='editedItem.customTitleId'
                hint='Please select a custom Title.'
                :items='codebooks'
                item-text='titleYear'
                item-value='id'
                label='Custom Title'
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols='8' sm='4' md='4' lg='5'>
              <v-menu
                ref='menu'
                v-model='menu'
                :close-on-content-click='false'
                :return-value.sync='editedItem.date'
                transition='scale-transition'
                offset-y
                min-width='290px'
              >
                <template v-slot:activator='{ on }'>
                  <v-text-field
                    v-model='editedItem.date'
                    label='Effective Date'
                    prepend-icon='mdi-calendar'
                    readonly
                    v-on='on'
                    clearable
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model='editedItem.date'
                  hint=' Please select an Effective Date'
                  persistent-hint
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color='error' @click='menu = false'>Cancel</v-btn>
                  <v-btn text color='success' @click='$refs.menu.save(editedItem.date)'>OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols='8' sm='4' md='4' lg='5'>
              <v-autocomplete
                v-model='editedItem.labelId'
                hint='Please select an Adoption Label.'
                :items='adoptionLabelList'
                :item-text='concatLabelPublisherAcr'
                item-value='id'
                label='Adoption Label'
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols='8' sm='4' md='4' lg='5'>
              <v-autocomplete
                v-model='defaultStatus'
                :rules='statusRules'
                hint='Please select an Adoption Status.'
                :items='defaultStatusItems'
                item-text='name'
                item-value='id'
                label='Adoption Status*'
              ></v-autocomplete>
            </v-col>
            <v-col cols='8' sm='4' md='4' lg='5'>
              <v-autocomplete
                v-model='defaultType'
                hint='Please select an Adoption Type.'
                :rules="typeRules"
                :items='defaultTypeItems'
                item-text='name'
                item-value='id'
                label='Adoption Type*'
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import CONSTANTS from './../../../../config/constant'
export default {
  data: () => ({
    valid: false,
    addDialog: false,
    formTitle: CONSTANTS.ADD_NEW_ADOPTION_FORM_TITLE,
    defaultStatusItems: CONSTANTS.ADOPTION_STATUS_FIELD,
    statusValues: CONSTANTS.DEFAULT_ADOPTION_STATUS_FIELD_VALUE,
    defaultStatus: CONSTANTS.DEFAULT_ADOPTION_STATUS_FIELD,
    defaultTypeItems: CONSTANTS.ADOPTION_TYPE_FIELD,
    typeValues: CONSTANTS.DEFAULT_ADOPTION_TYPE_FIELD_VALUE,
    defaultType: CONSTANTS.DEFAULT_ADOPTION_TYPE_FIELD,
    radios: '3',
    menu: false,
    isEditingState: false,
    stateErrorCheck: false,
    stateError: false,
    isEditingCounty: false,
    countyErrorCheck: false,
    countyError: false,
    isEditingJurisdiction: false,
    jurisdictionErrorCheck: false,
    isEditingTownship: false,
    townshipErrorCheck: false,
    totalAdoptions: 0,
    jurisdictionError: false,
    editedItem: {
      radioId: 1,
      date: '',
      countryId: '',
      stateId: '',
      countyId: '',
      jurisdictionId: '',
      townshipId: '',
      codeBookId: '',
      customTitleId: '',
      labelId: ''
    },
    defaultItem: {
      radioId: 1,
      date: '',
      countryId: '',
      stateId: '',
      countyId: '',
      jurisdictionId: '',
      townshipId: '',
      codeBookId: '',
      customTitleId: '',
      labelId: ''
    },
    countryRules: [v => !!v || 'Country name is required.'],
    stateRules: [v => !!v || 'State name is required.'],
    bookRules: [v => !!v || 'Code Book is required.'],
    typeRules: [v => !!v || 'Adoption Type is required.'],
    statusRules: [v => !!v || 'Adoption Status is required.'],
    countyRules: [v => !!v || 'County Name is required.'],
    townshipRules: [v => !!v || 'Township Name is required.'],
    jurisdictionRules: [v => !!v || 'Jurisdiction Name is required.']
  }),
  props: {
    userId: {
      type: Number,
      required: true
    },
    addDialogProp: {
      type: Boolean,
      required: true
    },
    totalAdoptionsProp: {
      type: Number
    }
  },
  computed: {
    dialog () {
      return this.addDialogProp
    },
    // to fetch publisher list
    publishers () {
      return this.$store.getters['PublisherModule/fetchPublisherList']
    },
    // to fetch code year list
    codeYearList () {
      return this.$store.getters['CodeYearModule/fetchCodeYearList']
    },
    countryList () {
      let cList = this.$store.getters['CountryModule/fetchCountryList']
      if (Object.keys(cList).length !== 0) {
        let newCList = this.$globalStates.makeUSAAsFirstItem(cList)
        return newCList
      } else {
        return cList
      }
    },
    stateList () {
      return this.$store.getters['StateModule/fetchStateList']
    },
    // to fetch code book list
    codebooks () {
      return this.$store.getters['CodeBookModule/fetchCodeBookList']
    },
    // to fetch adoption label list
    adoptionLabelList () {
      return this.$store.getters['AdoptionLabelModule/fetchAdoptionLabelList']
    },
    countyList () {
      return this.$store.getters['CountyModule/fetchCountyList']
    },
    jurisdictionList () {
      return this.$store.getters['JurisdictionModule/fetchJurisdictionList']
    },
    townshipList () {
      return this.$store.getters['TownshipModule/fetchTownshipList']
    }
  },
  methods: {
    // allowed Date method will be added in future
    // allowedDate (val) {
    //   let value = Date.parse(val)
    //   return value > Date.now()
    // },
    defaultRadio () {
      Object.assign(this.editedItem, this.defaultItem)
      this.isEditingState = false
      this.isEditingCounty = false
      this.isEditingJurisdiction = false
      this.isEditingTownship = false
    },
    closeDialog () {
      this.editedItem = Object.assign({}, this.defaultItem)
      this.defaultStatus = CONSTANTS.DEFAULT_ADOPTION_STATUS_FIELD
      this.defaultType = CONSTANTS.DEFAULT_ADOPTION_TYPE_FIELD
      this.radios = '3'
      this.isEditingState = false
      this.countyErrorCheck = false
      this.stateError = ''
      this.countyError = ''
      this.jurisdictionError = ''
      this.townshipError = ''
      this.stateErrorCheck = false
      this.countyErrorCheck = false
      this.jurisdictionErrorCheck = false
      this.townshipErrorCheck = false
      this.$refs.form.resetValidation()
      this.$emit('resetDialog', this.addDialog)
    },
    // Fetch state based on country ID selected from the dropdown
    filterState () {
      let fetchOnlyPublished = CONSTANTS.DEFAULT_RECORDS_STATUS_VALUE.Published
      if (this.editedItem.countryId) {
        this.isEditingState = true
      } else {
        this.isEditingState = false
      }
      const countryId =
        this.editedItem.countryId.id === undefined
          ? this.editedItem.countryId
          : this.editedItem.countryId.id
      new Promise((resolve, reject) => {
        this.$store.dispatch('StateModule/getStateList', {
          resolve,
          reject,
          countryId,
          fetchOnlyPublished
        })
      })
        .then(responseData => {
          this.editedItem.countyId = ''
          this.editedItem.jurisdictionId = ''
          this.editedItem.townshipId = ''
          this.isEditingCounty = false
          this.stateErrorCheck = false
          this.countyErrorCheck = false
          // add loader on button if required
        })
        .catch(response => {
          this.isEditingState = false
          this.editedItem.stateId = null
          this.stateErrorCheck = true
          this.stateError =
            CONSTANTS.NO_STATE_IS_AVAILABLE_FOR_THE_SELECTED_COUNTRY
          // add loader on button if required
        })
    },
    // Fetch county based on state ID selected from the dropdown
    filterCounty () {
      let fetchOnlyPublished = CONSTANTS.DEFAULT_RECORDS_STATUS_VALUE.Published
      if (this.editedItem.stateId) {
        this.isEditingCounty = true
      } else {
        this.isEditingCounty = false
      }
      const countryId =
        this.editedItem.countryId.id === undefined
          ? this.editedItem.countryId
          : this.editedItem.countryId.id
      const stateId =
        this.editedItem.stateId.id === undefined
          ? this.editedItem.stateId
          : this.editedItem.stateId.id
      new Promise((resolve, reject) => {
        this.$store.dispatch('CountyModule/getCountyList', {
          resolve,
          reject,
          countryId,
          stateId,
          fetchOnlyPublished
        })
      })
        .then(responseData => {
          this.editedItem.countyId = this.editedItem.countyId ? this.editedItem.countyId : ''
          this.countyErrorCheck = false
          if (this.radios === '3' || this.radios === '4') {
            this.filterJurisdiction()
          }
          // add loader on button if required
        })
        .catch(response => {
          this.isEditingCounty = false
          this.editedItem.countyId = null
          this.countyErrorCheck = true
          this.countyError =
            CONSTANTS.NO_COUNTY_IS_AVAILABLE_FOR_THE_SELECTED_STATE
          // add loader on button if required
          if (this.radios === '3' || this.radios === '4') {
            this.filterJurisdiction()
          }
        })
    },
    // Fetch jurisdiction based on county ID selected from the dropdown
    filterJurisdiction () {
      let fetchOnlyPublished = CONSTANTS.DEFAULT_RECORDS_STATUS_VALUE.Published
      if (this.editedItem.stateId) {
        this.isEditingJurisdiction = true
        this.isEditingTownship = true
      } else {
        this.isEditingJurisdiction = false
        this.isEditingTownship = false
      }
      const countryId =
        this.editedItem.countryId.id === undefined
          ? this.editedItem.countryId
          : this.editedItem.countryId.id
      const stateId =
        this.editedItem.stateId.id === undefined
          ? this.editedItem.stateId
          : this.editedItem.stateId.id
      let countyId = null
      if (this.editedItem.countyId) {
        countyId =
        this.editedItem.countyId.id === undefined
          ? this.editedItem.countyId
          : this.editedItem.countyId.id
      }
      // If the adoption type is jurisdiction based on radio button value will
      // Filter Jurisdictions based on selected country, state and county
      if (this.radios === '3') {
        new Promise((resolve, reject) => {
          this.$store.dispatch('JurisdictionModule/getFilteredJurisdictionList', {
            resolve,
            reject,
            countryId,
            stateId,
            countyId,
            fetchOnlyPublished
          })
        }).then(responseData => {
          this.editedItem.jurisdictionId = this.editedItem.jurisdictionId ? this.editedItem.jurisdictionId : ''
          this.jurisdictionErrorCheck = false
          // add loader on button if required
        }).catch(response => {
          this.isEditingJurisdiction = false
          this.editedItem.jurisdictionId = null
          this.jurisdictionErrorCheck = true
          this.jurisdictionError =
            CONSTANTS.NO_JURISDICTION_IS_AVAILABLE_FOR_THE_SELECTED_STATE_OR_COUNTY
          // add loader on button if required
        })
      } // end of if === 3
      // If the adoption type is township based on radio button value will
      // Filter Township based on selected country, state and county
      if (this.radios === '4') {
        new Promise((resolve, reject) => {
          this.$store.dispatch('TownshipModule/getFilteredTownshipList', {
            resolve,
            reject,
            countryId,
            stateId,
            countyId,
            fetchOnlyPublished
          })
        }).then(responseData => {
          this.editedItem.townshipId = this.editedItem.townshipId ? this.editedItem.townshipId : ''
          this.townshipErrorCheck = false
          // add loader on button if required
        }).catch(response => {
          this.isEditingTownship = null
          this.editedItem.townshipId = null
          this.townshipErrorCheck = true
          this.townshipError =
            CONSTANTS.NO_TOWNSHIP_IS_AVAILABLE_STATE_OR_COUNTY
          // add loader on button if required
        })
      } // end of if === 4
    },
    save () {
      if (this.$refs.form.validate()) {
        let statusField = 1
        let typeField = 1
        this.defaultStatus !== undefined && this.defaultStatus === 'Current Adoption'
          ? (statusField = this.statusValues.Current_Adoption)
          : (statusField = this.statusValues.Past_Adoption)
        if (this.defaultType !== undefined && this.defaultType === 'Proposed') {
          typeField = this.typeValues.Proposed
        } else if (this.defaultType !== undefined && this.defaultType === 'Denied') {
          typeField = this.typeValues.Denied
        } else if (this.defaultType !== undefined && this.defaultType === 'Approved') {
          typeField = this.typeValues.Approved
        }
        const formData = {
          adoptionLevel: Number(this.radios),
          countryId: this.editedItem.countryId.id
            ? this.editedItem.countryId.id
            : '',
          stateId: this.editedItem.stateId,
          countyId: this.editedItem.countyId === null ? '' : this.editedItem.countyId,
          jurisdictionId: this.editedItem.jurisdictionId === null ? '' : this.editedItem.jurisdictionId,
          townshipId: this.editedItem.townshipId === null ? '' : this.editedItem.townshipId,
          codeBookId: this.editedItem.codeBookId,
          customTitle: (this.editedItem.customTitleId !== undefined) ? this.editedItem.customTitleId : '',
          userId: Number(this.userId),
          effectiveDate: (this.editedItem.date !== undefined) ? this.editedItem.date : '',
          adoptionLableId: (this.editedItem.labelId !== undefined) ? this.editedItem.labelId : '',
          adoptionStatus: statusField,
          adoptionType: typeField
        }
        new Promise((resolve, reject) => {
          this.$store.dispatch('AdoptionModule/addAdoptionItem', {
            resolve,
            reject,
            formData
          })
        })
          .then(responseData => {
            this.$globalStates.notification.type = 'green'
            this.$globalStates.notification.text = responseData.responseMessage
            this.$globalStates.notification.init_notifications = true
            this.closeDialog()
          })
          .catch(response => {
            this.$globalStates.notification.type = 'error'
            this.$globalStates.notification.text = response.responseMessage
            this.$globalStates.notification.init_notifications = true
          })
        new Promise((resolve, reject) => {
          this.$store.dispatch('AdoptionModule/getAdoptionList', {
            resolve,
            reject
          })
        })
          .then(responseData => {
            this.totalAdoptions = responseData.pagination.totalRecords
            this.$emit('resetTotalAdoptions', this.totalAdoptions)
            this.loading = false
          })
          .catch(response => {
          })
      }
    },
    concatLabelPublisherAcr (item) {
      return item.adoptionLabel + ' (' + item.publisherAcronym + ')'
    }
  }
}
</script>
